import React from "react";

export default function Empty() {

    return <>
        <div id="emptyPlaceholder" className="stageEmpty isSmall">
            <div>
                <span name="enlarge" className="ji ji-enlarge"></span>
            </div>
            <div>Drag your first question here from the left.</div>
        </div>
    </>

}